import {OrderDto} from "./OrderDto";
import {ProductDto} from "./ProductDto";

export class CreateConfigurationDto {
	constructor(public Order: OrderDto, public Product: ProductDto) {}
}